import { getBootstrapBreakpoints } from '../../global/functions';

// eslint-disable-next-line import/prefer-default-export
export const setBlogMenuState = () => {
	const dropdown = document.querySelector('.topics-nav-dropdown');
	const toggle = document.querySelector('.topics-nav-title');
	const body = document.querySelector('body');

	toggle.addEventListener('click', () => {
		const isOpen = toggle.getAttribute('data-state') === 'open';

		dropdown.classList.toggle('active', !isOpen);
		toggle.setAttribute('data-state', isOpen ? 'closed' : 'open');
		body.style.overflow = isOpen ? 'auto' : 'hidden';
	});
};

/**
 * Initializes the search bar functionality.
 *
 * @param {string} querySelector - The query selector for the topics nav item.
 *
 * @returns {void}
 */
export const initSearchBar = (querySelector) => {
	// Timeout handler for debouncing search input
	let debounceTimeout;

	// Detect if viewing on mobile/small screen
	const isSmallScreen =
		getBootstrapBreakpoints().xs || getBootstrapBreakpoints().sm;

	// Get DOM elements needed for search functionality
	const searchButtonWrapper = document.getElementById(
		'search-button-wrapper',
	);
	const searchButton = document.getElementById('search-button');
	const closeIcon = document.getElementById('close-icon');
	const searchBarWrapper = document.getElementById('search-bar-wrapper');
	const searchInput = document.getElementById('search-input');
	const searchResults = document.getElementById('search-results');

	// Get topic navigation dropdowns if selector provided
	const topicsNavDropdowns = querySelector
		? document.querySelectorAll(querySelector)
		: null;

	// Toggle search bar visibility and handle related UI elements
	const toggleSearchBar = () => {
		const isVisible = searchBarWrapper.style.display === 'flex';
		searchBarWrapper.style.display = isVisible ? 'none' : 'flex';
		if (isVisible) {
			// If closing search, show search button and topic dropdowns
			searchButtonWrapper.style.display = isSmallScreen
				? 'block'
				: 'flex';
			topicsNavDropdowns?.forEach(
				(item) => (item.style.display = 'block'),
			);
		} else {
			// If opening search, hide search button and topic dropdowns
			searchButtonWrapper.style.display = 'none';
			topicsNavDropdowns?.forEach(
				(item) => (item.style.display = 'none'),
			);
		}
		// Auto-focus input when opening search
		if (!isVisible) searchInput.focus();
	};

	// Update search input border radius based on whether results are showing
	const updateSearchBarWrapperStyle = (isActive) => {
		searchInput.style.borderRadius = isActive ? '1rem 1rem 0 0' : '1rem';
	};

	// Display search results in the dropdown
	const displaySearchResults = (results) => {
		searchResults.innerHTML = '';
		if (results.length > 0) {
			// Create list of search result items
			const ul = document.createElement('ul');
			results.slice(0, 10).forEach((result) => {
				const li = document.createElement('li');
				li.className = 'search-results-item';
				const a = document.createElement('a');
				// Sanitize title text to prevent XSS
				a.innerHTML = result.title
					.replace(/</g, '&lt;')
					.replace(/>/g, '&gt;');
				a.href = result.url;
				li.appendChild(a);
				ul.appendChild(li);
			});
			searchResults.appendChild(ul);
			searchResults.classList.add('active');
			updateSearchBarWrapperStyle(true);
		} else {
			// Show "no results" message
			searchResults.innerHTML = `<p class="no-results px-4 py-2 text-start font-size-sm font-weight-regular">${searchInput.dataset.noResultsLabel}</p>`;
			searchResults.classList.add('active');
			updateSearchBarWrapperStyle(true);
		}
	};

	// Close search bar and reset all related UI elements
	const closeSearchBar = () => {
		searchBarWrapper.style.display = 'none';
		searchButtonWrapper.style.display = 'block';
		topicsNavDropdowns?.forEach((item) => (item.style.display = 'block'));
		searchInput.value = '';
		searchResults.innerHTML = '';
		searchResults.classList.remove('active');
		updateSearchBarWrapperStyle(false);
	};

	// Handle search input with debounced API calls
	const handleInput = () => {
		const query = searchInput.value.trim();
		// Clear existing results while typing
		searchResults.classList.remove('active');
		searchResults.innerHTML = '';
		updateSearchBarWrapperStyle(false);

		if (query.length > 0) {
			// Show loading spinner
			document.getElementById('spinner').style.display = 'flex';
			// Debounce API calls to prevent excessive requests
			clearTimeout(debounceTimeout);
			debounceTimeout = setTimeout(() => {
				// Make API call to WordPress backend
				fetch(
					`/wp-admin/admin-ajax.php?action=get_search_results&s=${encodeURIComponent(query)}&type=${searchInput.dataset.postType}&lang=${window.currentLanguage}`,
				)
					.then((response) => response.json())
					.then((data) => {
						document.getElementById('spinner').style.display =
							'none';
						if (data.success) {
							displaySearchResults(data.data);
						} else {
							searchResults.classList.remove('active');
							searchResults.innerHTML = '';
						}
					})
					.catch((error) => {
						document.getElementById('spinner').style.display =
							'none';
						console.error('Error fetching search results:', error);
					});
			}, 500); // Wait 500ms after last keystroke before searching
		} else {
			document.getElementById('spinner').style.display = 'none';
		}
	};

	// Set up event listeners
	searchButton.addEventListener('click', toggleSearchBar);
	closeIcon.addEventListener('click', closeSearchBar);
	searchInput.addEventListener('input', handleInput);
	// Close search when clicking outside
	document.addEventListener('click', (event) => {
		if (
			!searchBarWrapper.contains(event.target) &&
			!searchButton.contains(event.target)
		) {
			closeSearchBar();
		}
	});
};
